export default __webpack_public_path__ + "static/media/ipad-comments.3ce86419.jpg";